import { colorHex } from '@/utils/colors'
import { PartialLayerSpec } from '@/utils/layers/styleFactory/template'

export default (): PartialLayerSpec[] => {
  return [
    {
      id: 'fill',
      type: 'fill',
      layout: {},
      paint: {
        'fill-color': colorHex('poppy'),
        'fill-outline-color': 'rgba(0, 0, 0, 0)',
        'fill-opacity': [
          'case',
          [
            'all',
            ['!', ['boolean', ['feature-state', 'active'], false]], // don't highlight if active
            ['boolean', ['feature-state', 'hovered'], false]
          ],
          0.5,
          0
        ]
      }
    },
    {
      id: 'stroke',
      type: 'line',
      layout: {},
      paint: {
        'line-color': colorHex('poppy'),
        'line-width': [
          'case',
          ['boolean', ['feature-state', 'active'], false],
          3,
          0
        ],
        'line-dasharray': [1, 0.75]
      }
    }
  ] as PartialLayerSpec[]
}
